import { SupportedLanguage, useLanguage } from "../stores/language_store";
import { translations } from "../utils/translation";

interface TranslateProps {
  value: string;
}

export function Translate({ value }: TranslateProps) {
  const language = useLanguage();
  return translate(value, language);
}

export function translate(value: string, language: SupportedLanguage): string {
  return translations[value]?.[language] ?? "## MISSING TRANSLATION ##";
}
